/**
 * formatBytes - A file size for people: "96 KB", "4.1 MB".
 *
 * @param {number} bytes
 * @returns {string}
 */
export const formatBytes = (bytes) => {
    if (!bytes) return '0 KB'
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
